export default {
  errorBagName: 'errors',
  fieldsBagName: 'fields',
  // strict: true,
  classes: true,
  inject: true,
  events: 'input|blur',
};
